<script setup>
const props = defineProps({
  certification: {
    type: Object,
    required: true
  }
})

const user = useUser()
const ui = useUi()

const isSubscribed = computed(() => (user.data.metadata?.interest || []).includes(props.certification.id))

function subscribe () {
  user.addToQueue({
    method: 'saveMetadata',
    payload: { interest: [props.certification.id] },
    flashMessageKey: 'CERT_INTEREST_SUCCESS'
  })

  if (user.isGuest) ui.openAuthModal()
}
</script>

<template>
  <div
    class="flex w-full flex-col justify-between gap-5 rounded-2xl bg-eerie-black/5 p-6 md:gap-10 md:p-10 dark:bg-dark-gunmetal">
    <div class="grid gap-5 md:gap-10">
      <div class="flex items-center gap-8">
        <NuxtImg
          loading="lazy"
          :src="`/images/homepage/tech-${certification.name.toLowerCase()}.svg`"
          class="w-11"
          :alt="`Logo of ${certification.name}`" />
        <h2 class="heading-primary text-3xl font-bold md:text-[40px] md:leading-tight">
          {{ certification.name }}
        </h2>
      </div>
      <div class="flex items-center rounded-[10px] bg-white xl:h-[290px] dark:bg-[#07080E]">
        <NuxtImg
          loading="lazy"
          :src="`/images/homepage/card-${certification.name.toLowerCase()}.png`"
          class="hidden dark:block"
          :alt="`Certification of ${certification.name}`" />
        <NuxtImg
          loading="lazy"
          :src="`/images/homepage/card-${certification.name.toLowerCase()}-light.svg`"
          class="dark:hidden"
          :alt="`Certification of ${certification.name}`" />
      </div>
      <p class=" text-center text-base text-eerie-black md:text-left md:text-base dark:text-white">
        {{ certification.description }}
      </p>
    </div>
    <div
      v-if="isSubscribed"
      class="rounded-md bg-eerie-black/10 px-8 py-4 text-center font-bold text-white dark:bg-eerie-black/50">
      ✅ Subscribed
    </div>
    <button
      v-else
      class="btn-primary w-full px-8 py-4"
      @click="subscribe">
      {{ user.isGuest ? 'Sign Up for Updates' : 'Get Notified' }}
    </button>
  </div>
</template>
